export default "__VITE_ASSET__CzNAl__f__"